import {useState, FC, useEffect} from 'react';

import {FoodDiningSpaceData} from '@stencil/hotels-cg-reducer/src/details/types';

// Hooks
import useIsClient from '@stencil/hotels-hooks/src/useIsClient';

// Components
import DiningDetailsUI from '../../DiningDetailsUI/DiningDetailsUI';
import FoodOfferUI from '../../FoodOfferUI/FoodOfferUI';

import * as S from './MultiRestaurentCard.styles';

interface MultiRestaurentCardProps {
  data: FoodDiningSpaceData;
  index: number;
  activeAccordionIndex: number;
  setExpandedAccordion: Function;
}

const MultiRestaurentCard: FC<MultiRestaurentCardProps> = ({
  data,
  index,
  activeAccordionIndex,
  setExpandedAccordion,
}) => {
  const [open, setOpen] = useState(index === 0);
  const isClient = useIsClient();

  const {name, gallery, type, uspDishes} = data;
  const {avgMealCost, cuisines, timings, foodType} = data?.details;

  useEffect(() => {
    if (activeAccordionIndex !== index) {
      setOpen(false);
    }
  }, [activeAccordionIndex, index]);

  return (
    <>
      <S.MenuUIWrapper
        onClick={() => {
          setOpen(state => !state);
          setExpandedAccordion(index);
        }}
        data-testid="d-MultiRestaurentCard-wrap"
      >
        <S.HeadingWrap>
          <S.MenuHeader>{`${name} (${type})`}</S.MenuHeader>
          {isClient && (
            <S.ArrowDownNewWrap transformStyle={(open && 'rotate(180deg)') || 'rotate(0deg)'} />
          )}
        </S.HeadingWrap>
        <S.OfferContent display={!open && 'none'}>
          <DiningDetailsUI
            timings={timings}
            avgMealCost={avgMealCost}
            cuisines={cuisines}
            foodType={foodType}
          />
          {uspDishes && uspDishes.length > 0 && <FoodOfferUI offers={uspDishes} />}
        </S.OfferContent>
      </S.MenuUIWrapper>
    </>
  );
};

export default MultiRestaurentCard;
